import ufeApi from 'services/api/ufeApi';

function unlinkBiAccount(input) {
    const url = '/gway/v2/bi/unlinkAccount';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default unlinkBiAccount;
